import { darken, lighten, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  textFieldRoot: {
    borderRadius: 10,
    overflow: 'hidden',
    border: `1px solid #ABAFB3`,
  },
  label: {
    fontSize: 18,
    fontWeight: 300,
    color: '#464A53',
    paddingBottom: 5,
  },
  inputRoot: {
    display: 'flex',
    alignItems: 'stretch',
  },
  input: {
    padding: theme.spacing(8.25, 7.5),
    '&[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  underline: {
    '&&&:before': {
      borderBottom: 'none',
    },
    '&&:after': {
      borderBottom: 'none',
    },
  },
  button: {
    height: '100%',
    maxHeight: 26,
    fontWeight: 600,
    backgroundColor: '#17B0C3',
    color: '#fff',
    padding: '0px 20px',
    borderRadius: 0,
    overflow: 'hidden',
    fontSize: 20,
    '&:hover': {
      backgroundColor: darken('#17B0C3', 0.3),
    },
    '&.Mui-disabled': {
      color: '#fff',
      backgroundColor: lighten('#17B0C3', 0.3),
    },
  },
}));
